{
  "app_name": "radiri.news",
  "all_categories": "All",
  "sign_in": "Sign in",
  "sign_out": "Sign out",
  "register": "Register",
  "login": "Login",
  "logout": "Logout",
  "profile": "Profile",
  "account_settings": "Account settings",
  "toggle_theme": "Toggle theme",
  "toggle_theme_dark": "Switch to dark mode",
  "toggle_theme_light": "Switch to light mode",
  "toggle_theme_paper": "Switch to paper mode",
  "loading": "Loading…",
  "loading_more": "Loading more…",
  "no_stories": "No stories available.",
  "error_loading": "Could not load content. Please try again.",
  "article_count_one": "{{count}} article",
  "article_count_other": "{{count}} articles",
  "read_more": "Read more",
  "top_stories": "Top Stories",
  "significance": "Significance",
  "city_picker_title": "Select a city",
  "pick_city": "Choose a city to read the latest news.",
  "profile_coming_soon": "User profile coming soon.",
  "carousel_prev": "Previous",
  "carousel_next": "Next",
  "more_on_this_topic": "More on this topic",
  "related_articles": "Related Articles",
  "preferences": "Preferences",
  "theme": "Theme",
  "theme_light": "Light",
  "theme_dark": "Dark",
  "theme_paper": "Paper",
  "font_size": "Text size",
  "font_size_small": "Small",
  "font_size_medium": "Medium",
  "font_size_large": "Large",
  "language": "Interface language",
  "save_preferences": "Save preferences",
  "settings_saved": "Preferences saved.",
  "account_actions": "Account",
  "reset_password": "Reset password",
  "reset_password_code_sent": "A verification code was sent to your registered email address.",
  "reset_password_code_label": "Verification code",
  "reset_password_new_password_label": "New password",
  "reset_password_confirm": "Set new password",
  "reset_password_success": "Password updated successfully.",
  "cancel": "Cancel",
  "setup_passkey": "Set up passkey / security key",
  "passkey_success": "Passkey registered successfully.",
  "passkey_error": "Could not set up passkey. Please try again.",
  "passkey_not_supported": "Your browser does not support passkeys.",
  "change_email": "Change email address",
  "change_email_enter_hint": "Enter your new email address below.",
  "change_email_email_label": "New email address",
  "change_email_code_sent": "A verification code was sent to your new email address.",
  "change_email_code_label": "Verification code",
  "change_email_confirm": "Confirm email change",
  "change_email_success": "Email address updated successfully.",
  "coming_soon": "coming soon",
  "cognito_not_configured": "not configured",
  "not_signed_in": "You are not signed in.",
  "sign_in_to_access_settings": "Please sign in to access account settings.",
  "back_to_home": "← Back to home",
  "close": "Close",
  "human_check_title": "Are you human?",
  "human_check_description": "Please complete the check below before creating your account.",
  "human_check_verifying": "Verifying…",
  "human_check_error_generic": "Verification failed. Please try again.",
  "human_check_not_configured": "Human check is not configured.",
  "welcome_log_in": "Log in",
  "welcome_sign_up": "Sign up",
  "date_selector_label": "Date selector",
  "date_previous_day": "Previous day",
  "date_next_day": "Next day",
  "change_city_language": "Change city / language",
  "image_caption_text": "Artistic view of the story, inspired by the text and drawn by our AI.",
  "image_caption_info_aria": "More information about AI-generated images",
  "faq": "FAQ",
  "faq_title": "Frequently Asked Questions",
  "impressum": "Impressum",
  "privacy": "Privacy",
  "expand_all": "Expand All",
  "collapse_all": "Collapse All",
  "privacy_notice": "Privacy Notice",
  "token_refreshing": "Refreshing session\u2026",
  "low_impact_stories": "Also in the news",
  "city": "City",
  "news_language": "News language",
  "city_unavailable_tooltip": "Not available in {{lang}}. Available in: {{langs}}",
  "language_unavailable_tooltip": "Not available for {{city}}. Available languages: {{langs}}",
  "go": "Go",
  "select_city_and_language": "Select a city and a language to get started.",
  "delete_account": "Delete my account",
  "delete_account_tooltip": "Permanently deletes your account and all associated data. This cannot be undone.",
  "delete_account_danger_zone": "Danger Zone",
  "delete_account_modal_title": "Delete your account?",
  "delete_account_modal_warning": "This will permanently delete your account and all associated data. This action cannot be undone.",
  "delete_account_type_to_confirm": "Type DELETE to confirm:",
  "delete_account_confirm_placeholder": "delete",
  "delete_account_confirm_btn": "Yes, delete my account",
  "delete_account_success": "Account deleted.",
  "delete_account_error": "Failed to delete account. Please try again.",
  "deleting": "Deleting…"
}
